module.exports = __webpack_public_path__ + "img/logo-loverfans-black-white.1cae73bc.svg";